import React, { PropsWithChildren, createContext } from "react";
import { DefaultProps } from "./types";

export const DEFAULT_PROPS_CONTEXT_AHS_2024_THEME_VALUES: DefaultProps = {
  buttonDefaultProps: {
    color: "interactive",
    shape: "pill",
    size: "medium",
    variant: "filled",
  },
  globalFooterDefaultProps: {
    linkDefaultColor: "interactive",
    socialMediaLinksSmallVariantDefaultColor: "interactive",
  },
  panelDefaultProps: {
    border: "0",
    rounded: "xl",
  },
};

export const DefaultPropsContext = createContext<DefaultProps>(undefined);
DefaultPropsContext.displayName = "DefaultPropsContext";

/**
 * A context provider that provides a global "default props" state for its children sub-tree. These props & their values can be
 * used by descendent components that are supported by the Default Props Context. It allows conditionally rendering UI elements
 * and executing application logic based on this state. This ensures that the "Default Props" values provided for each
 * of the component would not be required to be set again at individual component level.
 *
 * It accepts `value` as a prop with default prop values per component. It holds this value as state. It renders its `children`
 * wrapped in context providers. These context providers make this state available to the supported components rendered within their
 * children sub-tree.
 */
export const DefaultPropsContextProvider = ({ children, value }: PropsWithChildren<{ value: DefaultProps }>) => {
  return <DefaultPropsContext.Provider value={value}>{children}</DefaultPropsContext.Provider>;
};
